/**
 * Created by toomasp on 23.11.2015.
 */
export class LoaderContext {
    static $inject = ['iframeChannel', 'app'];

    constructor(private iframeChannel, private app) {
        this._init();
    }

    _init() {
        this.iframeChannel.addBinding('showOverlay', this.show.bind(this));
        this.iframeChannel.addBinding('hideOverlay', this.hide.bind(this));
        this.iframeChannel.addBinding('showPartialLoadingOverlay', this.showPartialLoadingOverlay.bind(this));
        this.iframeChannel.addBinding('hidePartialLoadingOverlay', this.hidePartialLoadingOverlay.bind(this));
        this.iframeChannel.addBinding('showPartialModalOverlay', this.showPartialModalOverlay.bind(this));
        this.iframeChannel.addBinding('hidePartialModalOverlay', this.hidePartialModalOverlay.bind(this));
    }

    showOverlay = false;
    showPartialOverlay = false;
    showModalOverlay = false;

    show() {
        this.showOverlay = true;
        this.app.validate();
    }

    hide() {
        this._clearOverlays();
        this.app.validate();
    }

    showPartialLoadingOverlay() {
        this.showPartialOverlay = true;
        this.app.validate();
    }

    hidePartialLoadingOverlay() {
        this._clearOverlays();
        this.app.validate();
    }

    showPartialModalOverlay() {
        this.showModalOverlay = true;
        this.app.validate();
    }

    hidePartialModalOverlay() {
        this._clearOverlays();
        this.showModalOverlay = false;
        this.app.validate();
    }

    _clearOverlays() {
        this.showOverlay = false;
        this.showPartialOverlay = false;
    }
}


// WEBPACK FOOTER //
// ./src/main/ui/core/services/LoaderContext.ts